// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { asString, dataSanitizeMeasurements, dataSanitizeProperties, dataSanitizeString, dataSanitizeUrl, msToTimeSpan } from "@microsoft/applicationinsights-core-js";
import { _DYN_RESPONSE_CODE } from "../__DynamicConstants";
export var RequestEnvelopeType = "Microsoft.ApplicationInsights.{0}.Request";
/**
 * Constructs a new instance of the RequestData object
 */
export function createRequestData(logger, id, name, value, success, responseCode, source, url, properties, measurements) {
    var _a;
    return _a = {
            ver: 2,
            id: id,
            name: dataSanitizeString(logger, name),
            duration: msToTimeSpan(value),
            success: success
        },
        _a[_DYN_RESPONSE_CODE /* @min:responseCode */] = asString(responseCode || "0"),
        _a.source = dataSanitizeString(logger, source),
        _a.url = dataSanitizeUrl(logger, url),
        _a.properties = dataSanitizeProperties(logger, properties),
        _a.measurements = dataSanitizeMeasurements(logger, measurements),
        _a.aiDataContract = {
            id: 1 /* FieldType.Required */,
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            responseCode: 1 /* FieldType.Required */,
            duration: 1 /* FieldType.Required */,
            success: 1 /* FieldType.Required */,
            source: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        },
        _a;
}
//# sourceMappingURL=RequestData.js.map